import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _ContractModifyType } from '../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectContractModifyType = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ContractModifyType)
    const [id, setID] = useState<any>("");

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        if (e === "") {
            setID("");
            onChange(null)
        } else {
            setID(e);
            if (onChange) {
                onChange(selectedId)
            }
        }
    };

    const getLista = () => {
        instance.getContractModifyTypeCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        ).catch(err => {
            console.log(err)
        });
    };

    return (
        <>
            <label>{label ?? "Tipo de Modificación"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDContractModifyType} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}